// if all numbers are less than 5, return a default range [0, 5], otherwise return [null, null] letting the chart decide the domain
export const yDomainForData = (numbers: number[]): [number | null, number | null] => {
	const max = Math.max(...numbers);
	return max < 5 ? [0, 5] : [null, null];
};

export const yDomainForChartData = (data: { value: number }[]): [number | null, number | null] => {
	return yDomainForData(data.map((d) => d.value));
};
